import { EnumAlertaNivel } from './enums/enumAlertaNivel';
import { EnumAlertaStatus } from './enums/enumAlertaStatus';
import { EnumAlertaTipo } from './enums/enumAlertaTipo';
import { Generico } from './generico';

export class AlertaModel extends Generico {
    titulo: string;
    mensagem: string;
    nivel: EnumAlertaNivel;
    status: EnumAlertaStatus;
    tipo: EnumAlertaTipo;

    usuarioId: string
    contaId: number;
    entidadePublicaId: number;
    bilhetadoraId: number;
    operadoraId: number;
    consorcioId: number;
    lojaId: number;
    gestorId: number;

    constructor(item?) {
        super(item);

        if (item) {
            this.titulo = item.titulo;
            this.mensagem = item.mensagem;
            this.nivel = item.nivel;
            this.status = item.status;
            this.tipo = item.tipo;

            this.usuarioId = item.usuarioId
            this.contaId = item.contaId;
            this.entidadePublicaId = item.entidadePublicaId;
            this.bilhetadoraId = item.bilhetadoraId;
            this.operadoraId = item.operadoraId;
            this.consorcioId = item.consorcioId;
            this.lojaId = item.lojaId;
            this.gestorId = item.gestorId;
        }
    }
}
